import { Image } from 'react-native';

// leave off @2x/@3x
const images = {
  // Icon Images
  ic_sync: Image.resolveAssetSource(require('./../Assets/Images/Icons/ic_sync.png')),
  ic_arrow_left_white: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icArrowLeftWhite.png'),
  ),
  ic_info_circle: Image.resolveAssetSource(require('./../Assets/Images/Icons/icInfoCircle.png')),
  ic_mobile: Image.resolveAssetSource(require('./../Assets/Images/Icons/icMobile.png')),
  icFaceRecognitionRed: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icFaceRecognitionRed.png'),
  ),
  icBiometricAuthenticationRed: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icBiometricAuthenticationRed.png'),
  ),
  ic_language: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icInternetGlobeCountryWhite.png'),
  ),
  icBritishFlag: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icons_indicators_flags_britain.png'),
  ),
  icHungaryFlag: Image.resolveAssetSource(
    require('../Assets/Images/Icons/iconsIndicatorsFlagsHungary.png'),
  ),
  icBritishFlag1: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icons_indicators_flags_britain.png')
  ),
  icAlbanianFlag: Image.resolveAssetSource(
    require('../../../../App/Group/Assets/Images/icons_indicators_flags_albanian.png')
  )
};

export default images;
